// @flow
import React from 'react';
import Experiment, {Variant} from '@homeaway/react-experiment';
import {SVGIcon} from '@homeaway/react-svg';
import {VIEWED_COLOR__24, THUMB__24} from '@homeaway/svg-defs';
import {ButtonLink} from '@homeaway/react-buttons';
import {FormattedMessage} from 'react-intl';
import {VRBO_SERP_SEE_MORE_PROMPT} from '../../../abacus/experiments';
import {triggerPropertyHitPromptSelectedEvent} from '../../../utils/collectionEdapUtils';

type Props = {
    dispatch: Function,
    listingId: string
};

const SeeMore = ({dispatch, listingId}: Props) => {
    return (
        <div className="SeeMore">
            <Experiment name={VRBO_SERP_SEE_MORE_PROMPT} deferLogging>
                <Variant variant={1}>
                    <SVGIcon
                        markup={VIEWED_COLOR__24}
                        className={'SeeMore__icon'}
                    />
                    <p className="SeeMore__text">
                        <FormattedMessage
                            id="see.more"
                            description="See more like this?"
                            defaultMessage="See more like this?"
                        />
                    </p>
                    <div className="SeeMore__buttons">
                        <ButtonLink
                            id={'yes'}
                            onClick={() => {
                                dispatch({
                                    type: 'NAVIGATE_YES'
                                });
                                triggerPropertyHitPromptSelectedEvent(
                                    listingId,
                                    true
                                );
                            }}
                            label={
                                <FormattedMessage
                                    id="yes"
                                    description="Yes"
                                    defaultMessage="Yes"
                                />
                            }
                        />
                        <ButtonLink
                            id={'no'}
                            onClick={() => {
                                dispatch({
                                    type: 'NAVIGATE_NO'
                                });
                                triggerPropertyHitPromptSelectedEvent(
                                    listingId,
                                    false
                                );
                            }}
                            label={
                                <FormattedMessage
                                    id="no"
                                    description="No"
                                    defaultMessage="No"
                                />
                            }
                        />
                    </div>
                </Variant>
                <Variant variant={2}>
                    <p className="SeeMore__text">
                        <FormattedMessage
                            id="see.more"
                            description="See more like this?"
                            defaultMessage="See more like this?"
                        />
                    </p>
                    <div className="SeeMore__buttons">
                        <button
                            className={'SeeMore__thumb SeeMore__thumb-up'}
                            onClick={() => {
                                dispatch({type: 'NAVIGATE_YES'});
                                triggerPropertyHitPromptSelectedEvent(
                                    listingId,
                                    true
                                );
                            }}
                        >
                            <SVGIcon markup={THUMB__24} />
                        </button>
                        <button
                            className={'SeeMore__thumb SeeMore__thumb-down'}
                            onClick={() => {
                                dispatch({type: 'NAVIGATE_NO'});
                                triggerPropertyHitPromptSelectedEvent(
                                    listingId,
                                    false
                                );
                            }}
                        >
                            <SVGIcon markup={THUMB__24} />
                        </button>
                    </div>
                </Variant>
            </Experiment>
        </div>
    );
};

export default SeeMore;
